module.exports = __webpack_public_path__ + "media/images/area/area_kumamotoM400-0831d3a0b631a395e16c7c4b786204c7.jpg";